import { Component, Optional } from '@angular/core';
import { ItemsListActionComponent } from './items-list-action.component';
import {
  ActionResult,
  DataSource,
  ListView,
  ListViewProviderDirective,
  NotificationService,
  ViewData,
  ViewResult,
  ViewWindow
} from '@ntap/core';
import { Observable, first, tap } from 'rxjs';

@Component({
  selector: 'app-basic-item-list',
  templateUrl: '../../../shared/components/actions/common-action-template.html'
})
export class BasicItemsListActionComponent extends ItemsListActionComponent {
  constructor(
    @Optional() public window: ViewWindow,
    notificationService: NotificationService,
    dataSource: DataSource,
    listViewProvider: ListViewProviderDirective<ListView>
  ) {
    super(notificationService, dataSource, listViewProvider);
  }

  private closeWindow() {
    this.window.close();
  }

  protected override doExecute(): Observable<ActionResult> {
    const result$: Observable<ActionResult> = super
      .doExecute()
      .pipe(tap((result) => this.applyResultToView(result)));
    if (this.isCloseAction()) {
      this.result$.pipe(first()).subscribe({
        // next: result =>  Object.keys(result).length > 0 && this.closeWindow(),
        error: () => this.closeWindow(),
        complete: () => this.closeWindow()
      });
    }
    return result$;
  }

  private applyResultToView(result: ActionResult) {
    const viewResult: ViewResult = new ViewResult(
      {} as ViewData,
      1,
      true,
      result
    );
    this.listViewProvider.setViewResult(viewResult);
  }
}
